// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { Button } from '@imprivata-cloud/design-system';
import { useTranslation } from 'react-i18next';
import EmptyStateIllustration from '../../../../assets/empty-list.svg';

const TRANSLATION_ROOT = 'portal.settings.endpoints.empty';

/** No endpoints registered for the tenant. Prompts installing the agent. */
export const EndpointsEmpty = ({ onOpenSettings }: { onOpenSettings: () => void }) => {
  const { t } = useTranslation();
  return (
    <div className="endpoints-empty">
      <img src={EmptyStateIllustration} alt="" />
      <p className="endpoints-empty-title">{t(`${TRANSLATION_ROOT}.no-endpoints-title`)}</p>
      <p className="endpoints-empty-text">{t(`${TRANSLATION_ROOT}.no-endpoints-text`)}</p>
      <Button variant="link" className="endpoints-empty-link" onClick={onOpenSettings}>
        {t(`${TRANSLATION_ROOT}.install-link`)}
      </Button>
    </div>
  );
};

/** An active search/filter matched no endpoints. */
export const EndpointsNoResults = () => {
  const { t } = useTranslation();
  return (
    <div className="endpoints-empty">
      <img src={EmptyStateIllustration} alt="" />
      <p className="endpoints-empty-title">{t(`${TRANSLATION_ROOT}.no-results-title`)}</p>
      <p className="endpoints-empty-text">{t(`${TRANSLATION_ROOT}.no-results-text`)}</p>
    </div>
  );
};
